import React from 'react';
import { NextSeo } from 'next-seo';
import { getBlogPosts, queryPageData, queryBlogPost } from 'lib/dato-request';
import { Layout } from 'components/Layout';
import { TestimonialCarousel } from 'components/TestimonialCarousel';
import { FormCardPanel } from 'components/FormCardPanel';
import Image from 'next/legacy/image';
import StructuredText from '@/components/ReusableUI/StructuredText';
import SecondaryPageLayout from '@/components/ReusableUI/SecondaryPageLayout';
import { ContactForm } from '@/components/Contact';
import Head from 'next/head';

interface ImageRecord {
    url: string;
    height: number;
    width: number;
    alt?: string;
    customData?: any;
    responsiveImage: any;
}

interface ImageGalleryRecord {
    images: Array<ImageRecord>;
}

// export default function BlogPost(props) {
//     const components = props?.components?.page.components;
//     const post = props?.data.blogPost;
// <<<<<<< Updated upstream
// export default function BlogPost(props) {
//     const components = props?.components?.page.components;
//     console.log(props);
//     const post = props?.data.blogPost;
//     console.log(post);
// =======
export default function BlogPost({ data, page }) {
    const { components, seo } = page.page;
    const post = data.blogPost;
    // Find the next post after this post
    // const nextPost = props?.allPosts.allBlogPosts.filter(item => item.title !== post.title)[0];
    return (
        <Layout showClassCodeInput={false}>
            <NextSeo title={`Muzology | ${post?.title}`} description={seo?.description ?? post?.description} />
            <Head>
                <meta name='keywords' content={page.keywords} />
            </Head>
            <div className='post-wrapper p-six-four-two'>
                {post?.featuredImage
                    // <Image image={post?.featuredImage} className='post-featured-image' />}
                    && <Image
                        // Data={post.featuredImage}
                        src={post.featuredImage.url}
                        width={post.featuredImage.width}
                        height={post.featuredImage.height}
                        loading='eager'
                        alt='featured image'
                    />}

                <h1 className='post-title'>{post?.title}</h1>

                <StructuredText styleName='structured-text-block--blog' data={post?.contents} />

            </div>
            <style jsx>{`
                .post-wrapper {
                    margin: 0 auto;
                    padding-top: 80px;
                    width: 100%;
                    max-width: 820px;
                }

                #back-to-blog {
                    cursor: pointer;
                    transition: color 100ms linear;
                }

                #back-to-blog:hover {
                    color: #121651;
                }

                .post-title {
                    font-weight: 800;
                    font-size: 40px;
                    line-height: 48px;
                    background: -webkit-linear-gradient(135deg,
                    #e637a8 2.69%,
                    #e68137 75%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    text-decoration-line: underline;
                    display: flex;
                    margin-top: 24px;
                }

                .image-gallery {
                    display: flex;
                    flex-direction: row;

                    .image-gallery-item {
                        margin: 10px;
                        background: red;
                    }

                }
            `}</style>
        </Layout>
    );
}

export async function getStaticPaths() {
    const data = await getBlogPosts();
    // filter(post => post.visible).
    const paths = data.allBlogPosts
        .filter(post => post.visible)
        .map(post => ({
            params: { slug: post.slug }
        }));
    return { paths, fallback: false };
}

export async function getStaticProps({ params }) {
    const { slug } = params;
    const data = await queryBlogPost(slug);
    const page = await queryPageData('Blog');
    // const allPosts = await getBlogPosts();
    return {
        props: { data, page }
    };
}

